import React, {useEffect, useState} from "react";
import { request } from 'graphql-request';
import CaseStudy from "../includes/caseStudy";

const FeaturedCaseStudy = () => {
    const [caseStudy, setCaseStudy] = useState(null);
    const [loading, setLoading] = useState(true);
    const featuredCaseStudyID = "clg1o9bdw76mp0ak9yexsun3q";

    useEffect(() => {
        const fetchCaseStudy = async () => {
            const {caseStudies} = await request(
                `https://us-east-1-shared-usea1-02.cdn.hygraph.com/content/${process.env.REACT_APP_CS_KEY}/master`,
                `
                {
                    caseStudies(where: {id: "${featuredCaseStudyID}"}) {
                        id
                        companyName
                        logoWhite {
                            url
                        }
                        logoBlack {
                            url
                        }
                        backgroundCopy
                        challengesCopy
                        solutionCopy
                        resultsCopy
                        conclusionCopy
                        statisticNumber1
                        statisticText1
                        statisticNumber2
                        statisticText2
                        statisticNumber3
                        statisticText3
                    }
                }
            `
            );
            setCaseStudy(caseStudies && caseStudies.length > 0 ? caseStudies[0] : null);
            setLoading(false);
        }
        fetchCaseStudy();
    }, []);

    return (
        <div className="w-full flex flex-col items-center justify-center gap-10 py-20">
            {!loading && caseStudy && (
                <CaseStudy caseStudy={caseStudy} key={caseStudy.id} index={1} active={true} isFeatured={true}/>
            )}
        </div>
    );
}

export default FeaturedCaseStudy;